export enum FileView {
  Tile = 'tile',
  Row = 'row'
}



// WEBPACK FOOTER //
// ./src/app/models/file-view.enum.ts